import axios from 'axios';
import base from '@/api/base.api';
const namespace = 'zip-code';

export default {
    search: (params) => {
        return axios.post(`${base.baseUrl}/${namespace}/search`, params)
    }
}
